import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { getErrorText } from '../helpers';

type FetchMessagesParams = {
  channels: [string];
  count: number;
  start?: string;
};

export const getBlockedUsers = createAsyncThunk<
  Pubnub.FetchMessagesResponse['channels'][number],
  { roomId: string; loadMore?: boolean },
  { rejectValue: string }
>('pubnub/getBlockedMessages', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;
    const { messages } = pubnubReducer?.blocked;

    const fetchMessagesParams: FetchMessagesParams = {
      channels: [data.roomId],
      count: 25,
    };

    if (data.loadMore && messages && messages.length) {
      const lastMessage = messages.slice(-1)[0];
      if (lastMessage) {
        fetchMessagesParams.start = `${lastMessage.timetoken}`;
      }
    }

    if (pubnubReducer.pubnub) {
      const result = await pubnubReducer.pubnub.fetchMessages(fetchMessagesParams);

      return result.channels[data.roomId];
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
